module.exports = __webpack_public_path__ + "assets/11a2433c83697d6aeced569851db36ec.png";